export const environment = {
	production: false,
	baseUrl: 'https://api.coredev.codeblack.mt/api/v1',//'https://api.desiraholdings.codeblack.mt/api/v1'
	PendergardensUrl: 'https://api.pendercarpark.codeblack.mt/api/v1',
	per_page : 25
	//ws_url: 'https://api.zenith.dev.codeblack.mt/broadcasting/auth'
  };
  